export default __webpack_public_path__ + "static/media/game-analytics.fe62a27a.svg";